<!--
 * @Description: 电子票页
 * @Author: 山淑兰
 * @Date: 2019-11-12 15:16:19
 * @LastEditTime: 2020-07-15 15:37:32
 * @LastEditors: 山淑兰
 -->
<template>
  <div id="electronicTicket">
    <Loading v-if="show"></Loading>
    <div class="electronicTicket_container" v-else>
      <div class="screenshotPart">
        <div class="electronicTicket-banner">
          <img :src="meetingInfo.MobileBannerImage" alt />
        </div>
        <div class="loading" v-if="!showCon">
          <van-loading
            type="spinner"
            color="#3b82f6"
            vertical
            size="30px"
            text-size="16px"
            >{{ loadingMsg }}</van-loading
          >
        </div>
        <div
          class="electronicTicket_content commonW"
          v-else-if="showCon"
          ref="imageDom"
        >
          <div class="electronicTicket_fareInformation">
            <div class="fareInformation_header">
              <div class="fareInformation_header_nameInfo"  v-if="!tipsVisible">
                <span>{{ userInfo.username }}</span>
                <span>({{ userInfo.userphone }})</span>
              </div>
            </div>
            <div class="fareInformation_content" v-if="!userInfo.ischeckin">
              <div v-if="!tipsVisible">
                <div class="QR-code">
                  <div v-if="showQR">
                    <van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="14px">加载中...</van-loading>
                  </div>
                  <div id="qrcode"></div>
                </div>
                <span class="noSignIn">未签到</span>
                <div class="QR-code_msg">请在活动现场出示此二维码</div>
              </div>
              <div v-if="tipsVisible" style="color: #f56c6c;text-align: center;">
                {{tipsText}}
              </div>
            </div>
            <div class="fareInformation_content success" v-else>
              <h2>已签到</h2>
              <p>欢迎您参加本次会议！</p>
            </div>
            <div class="conferenceInfo">
              <ul class="conferenceInfo_lists">
                <li class="onferenceInfo_lists_item">
                  <div>{{ meetingInfo.MeetingTitle }}</div>
                  <!-- <van-icon name="arrow" /> -->
                </li>
                <li class="onferenceInfo_lists_item">
                  <div class="lists_item_tit">时间：</div>
                  <div class="onferenceInfo_item_date lists_item_cont">
                    {{ date }}
                  </div>
                </li>
                <li class="onferenceInfo_lists_item" @click="toAddress()">
                  <div class="lists_item_tit">地点：</div>
                  <div class="lists_item_cont">{{ address }}</div>
                  <van-icon name="arrow" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="download_btn commonW" v-show="showCon">
        <div class="download_btn_container">
          <span @click="clickGeneratePicture()">
            <span>保存电子票</span>
            <img src="@assets/down.png" alt class="downloadIcon" />
          </span>
        </div>
        <van-popup v-model="showDownloadImg" closeable>
          <div class>长按图片保存二维码</div>
          <div class="DownloadImgs">
            <img :src="imgUrl" alt />
          </div>
        </van-popup>
      </div>
      <!-- <Back></Back> -->
    </div>
    <div id="csbase64"></div>
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
import wxShare from '../../lib/wxShare.js'
import commonMeans from '../../lib/signUp.js'
import QRCode from 'qrcodejs2'
import Loading from '@components/Loading.vue'
// import Back from './components/backBtn.vue'

export default {
  name: 'electronicticket',
  components: {
    Loading
  },
  data() {
    return {
      address: '',
      imgUrl: '',
      showDownloadImg: false,
      lats: {},
      headRess: '',
      show: true, //加载动画
      showCon: false,
      loadingMsg: '加载中...',
      commonMeans: {}, //通用commonMeans
      m: '',
      muid: '',
      meetingInfo: {}, //会议基本数据
      userInfo: {}, //用户信息
      date: '',
      time: '',
      showCode: 0,
      showQR: true,
      tipsText: '',
      tipsVisible: false,
    }
  },

  created() {
    this.commonMeans = new commonMeans()
    this.m = this.$route.query.m
    this.muid = this.$route.query.muid

    this.getMeetingInfo()
    // // ==========
    if (process.env.NODE_ENV !== 'development') {
      this.init()
    }
  },
  mounted() {
    this.getQR_code()
    // setInterval(() => {
    //   this.getQR_code()
    // }, 1000)
  },
  methods: {
    //生成二维码
    // qrcode(link) {
    //   new QRCode('qrcode', {
    //     width: 154,
    //     height: 140, // 高度
    //     text: link, // 二维码内容
    //     render: 'table', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    //     correctLevel: QRCode.CorrectLevel.H,
    //   })
    // },
    //获取会议基本信息
    async getMeetingInfo() {
      this.loading = true
      let opt = {
        m: this.m,
      }
      this.meetingInfo = await this.commonMeans.init(opt, this)

      if (this.meetingInfo.Code === 1000) {
        this.address = this.meetingInfo.meetingaddress
        this.date = this.meetingInfo.TimerSpan

        this.show = false
      }
    },

    //获取二维码
    async getQR_code() {
      let params = {
        m: this.m,
        mu: this.muid,
      }
      let res = await this.$http.InitCheckUser(params)

      let _CurUserEntity = res.CurUserEntity

      if (res.Code === 1000) {
        this.showCon = true
        this.tipsVisible = false 
        if (!_CurUserEntity.ischeckin && !this.showCode) {
          this.userInfo = _CurUserEntity
          this.$nextTick(() => {
            //this.qrcode(res.CoderKey)
            setTimeout(() => {
              this.showQR = false
              new QRCode('qrcode', {
                width: 154,
                height: 140, // 高度
                text: res.CoderKey, // 二维码内容
                render: 'table', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                correctLevel: QRCode.CorrectLevel.H,
              })
            }, 100);

          })
          this.showCode = 1
        } else if (_CurUserEntity.ischeckin !== this.userInfo.ischeckin) {
          this.userInfo = _CurUserEntity
          this.showCode = 0
        }
      }else if( res.Code === 7001 || res.Code === 7002){
          this.showCon = true
          this.tipsText = res.Msg
          this.tipsVisible = true 
      }

      this.initMap(this.address)
    },

    //转base64
    getUrlBase64(url, ext, callback) {
      var canvas = document.createElement('canvas') //创建canvas DOM元素
      var ctx = canvas.getContext('2d')
      var img = new Image()
      img.setAttribute('crossOrigin', 'anonymous')
      // img.crossOrigin = 'Anonymous';
      // img.src = url;
      img.onload = function() {
        canvas.height = 60 //指定画板的高度,自定义
        canvas.width = 85 //指定画板的宽度，自定义
        ctx.drawImage(img, 0, 0) //参数可自定义
        var dataURL = canvas.toDataURL('image/' + ext)
        callback.call(this, dataURL) //回掉函数获取Base64编码
        canvas = null
      }
      img.src = url + '?time=' + new Date().valueOf()
    },

    // =------
    // 点击保存图片
    async clickGeneratePicture() {
      // this.getUrlBase64(this.meetingInfo.MobileBannerImage, 'jpg', (de) => {
      //   console.log(de)
      // })

      // var proxy = require('html2canvas-proxy');
      // var express = require('express');

      // var app = express();
      // app.use('/', proxy());

      setTimeout(() => {
        this.showDownloadImg = true
        this.$nextTick(async () => {
          // document.documentElement.scrollTop = 0;
          // document.body.scrollTop = 0;
          const _canvas = await html2canvas(this.$refs.imageDom, {
            backgroundColor: 'transparent',
            useCORS: true,
            logging: false,
          })
          // 转成图片，生成图片地址,将图片地址赋给弹框中
          const url = _canvas.toDataURL('image/jpeg')
          this.imgUrl = url
        })
      }, 500)
    },
    // -----------------------
    initMap(address) {
      let thisd = this
      var AMap = window.AMap
      new AMap.Map('mapContainer', {
        resizeEnable: true, //是否监控地图容器尺寸变化
        zoom: 12, //初始地图级别
      })
      AMap.plugin('AMap.Geocoder', function() {
        var geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          // city: '010'
        })
        geocoder.getLocation(address, function(status, result) {
          // console.log(status, result, '++++')
          if (status === 'complete' && result.info === 'OK') {
            const { geocodes } = result
            // const { formattedAddress, location } = geocodes[0]
            const { location } = geocodes[0]
            const { lat, lng } = location
            thisd.lats = { lat, lng }
          }
        })
      })
    },
    //判断是否为微信访问
    isWeiXin() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase()
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    async init() {
      try {
        const headRes = await this.$http.csData({
          url: encodeURIComponent(
            window.location.href.replace(location.hash, '')
          ),
        })
        console.log(headRes, 'headRes')
        const _Wx = new wxShare({
          opt: headRes,
        })
        this.headRess = _Wx
      } catch (err) {
        console.log(err)
      }
    },
    // 打开地图
    toAddress() {
      if (this.isWeiXin()) {
        console.log(this.lats, 'this.lats')
        let lat = this.lats.lat
        let lng = this.lats.lng
        console.log(lat, lng, '21')
        this.headRess.ready().then((wx) => {
          this.headRess.map(
            lat,
            lng,
            this.meetingInfo.city,
            this.meetingInfo.meetingaddress
          )
          console.log(wx)
        })
      } else {
        window.location.href = `https://m.amap.com/search/mapview/keywords=${this.address}&cluster_state=5&pagenum=1`
      }
    },
  },
}
</script>
<style lang="scss">
.tips-box{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(0,0,0,.5);
    .tips-con{
        position: absolute;
        width: 70%;
        background: #fff;
        top: 50%;
        left: 50%;
        z-index: 1000;
        transform: translate(-50%,-50%);
        font-size: 30px;
        text-align: center;
        border-radius: 12px;
        overflow: hidden;
        .tips-text{
            height: 130px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .tips-group{
            display: flex;
            height: 90px;
            border-top: 1px solid #e2e8f0;
            >div{
                flex: 1;
                line-height: 90px;
            }
            >div:last-child{
                // background: #3b82f6;
                color: #3b82f6;
            }
        }
    }
}
#electronicTicket {
  .van-icon-cross {
    color: #fff;
    font-size: 38px;
    top: 30px;
  }
  #qrcode {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
<style lang="scss" scoped>
.commonW {
  width: 92%;
  margin: 0 auto;
}
// -----------------
#electronicTicket {
  padding-bottom: 100px;
  .electronicTicket_container {
    .screenshotPart {
      padding-bottom: 20px;
    }
    .electronicTicket-banner {
      > img {
        width: 100%;
      }
    }
    .electronicTicket_content {
      background: #fff;
      margin: 40px auto;
      box-shadow: 0 2px 12px rgba(0,0,0,0.04); border: 1px solid #e2e8f0;
      .electronicTicket_fareInformation {
        width: 90%;
        margin: 0 auto;
        .fareInformation_header {
          font-size: 28px;
          color: #475569;
          line-height: 60px;
          padding: 20px 0;
          border-bottom: 2px solid #e2e8f0;
          .fareInformation_ticketPrice_price {
            margin: 0 10px;
            font-size: 34px;
          }
        }
        .fareInformation_content {
          width: 100%;
          padding: 60px 0 30px;
          border-bottom: 2px dashed #e2e8f0;
          margin-bottom: 10px;
          position: relative;
          text-align: center;
          line-height: 60px;
          font-size: 32px;
          color: #67C23A;
          &::after {
            content: '';
            width: 30px;
            height: 30px;
            position: absolute;
            left: -8%;
            bottom: 0;
            transform: translateY(50%);
            background: transparent;
            border-radius: 30px;
          }
          &::before {
            content: '';
            width: 30px;
            height: 30px;
            position: absolute;
            right: -8%;
            bottom: 0;
            transform: translateY(50%);
            background: transparent;
            border-radius: 30px;
          }
          .QR-code {
            width: 280px;
            height: 280px;
            margin: 0 auto;
            text-align: center;
            border: 2px solid #e2e8f0;
            padding: 20px;
          }
          .noSignIn {
            color: #f56c6c;
          }
          .QR-code_msg {
            color: #94a3b8;
            font-size: 24px;
          }
        }
        .success {
          height: 414px;
          padding: 60px 0 60px;
          text-align: center;
          > h2 {
            margin-top: 20%;
          }
        }
        .conferenceInfo {
          .conferenceInfo_lists {
            font-size: 28px;
            .onferenceInfo_lists_item {
              line-height: 80px;
              border-bottom: 2px solid #e2e8f0;
              position: relative;
              padding-right: 2%;
              color: #475569;
              display: flex;
              align-items: center;
              &:last-child {
                border-bottom: 0;
              }
              .onferenceInfo_item_date {
                margin-right: 10px;
              }
              > .van-icon {
                font-size: 40px;
                color: #94a3b8;
                position: absolute;
                top: 50%;
                right: -2%;
                transform: translateY(-50%);
              }
              .lists_item_tit {
                margin-right: 5%;
              }
              .lists_item_cont {
                flex: 1;
                margin-right: 20px;
                line-height: 40px;
              }
            }
          }
        }
      }
    }

    .download_btn {
      .download_btn_container {
        text-align: right;
        font-size: 24px;
        .downloadIcon {
          width: 30px;
        }
      }
      .van-popup {
        width: 80%;
        height: 80%;
        background-color: rgba(0, 0, 0, 0);
        overflow-y: hidden;
        > div {
          height: 60px;
          font-size: 30px;
          line-height: 100px;
          height: 100px;
          text-align: center;
          color: #fff;
        }
        .DownloadImgs {
          width: 100%;
          height: 80%;
          overflow-y: scroll;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
